
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { getDefaultValueType } from './defaults.mjs.js';
import { filter } from '../../../../../../style-value-types/dist/es/complex/filter.mjs.js';
import { complex } from '../../../../../../style-value-types/dist/es/complex/index.mjs.js';

function getAnimatableNone(key, value) {
    var _a;
    var defaultValueType = getDefaultValueType(key);
    if (defaultValueType !== filter)
        defaultValueType = complex;
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}

export { getAnimatableNone };
//# sourceMappingURL=animatable-none.mjs.js.map
